import {
  FOCUS_DEVICE
} from './constants'

export function focusDevice (data) {
  return {
    type: FOCUS_DEVICE,
    data
  }
}

export function reducer (state, action) {
  switch (action.type) {
    case FOCUS_DEVICE:
      return {
        ...state,
        focusDevice: action.data,
        focusEvent: null // Clear focusEvent when focusing a device
      }

    default:
      return state
  }
}
